import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  defaultFullscreenPageStyling,
  pageWithBottomNavigationStyling,
} from "../../../../theme";
import BottomNavigation from "../../../Common/components/BottomNavigation";
import HealthProfile from "../../components/HealthProfile";
import LoadingSpinner from "../../../Common/components/LoadingSpinner";
import useGetHealthProfile from "../../../Common/hooks/useGetHealthProfile";
import HealthScoreHeader from "@/features/HealthScore/components/HealthScoreHeader";

export default function MyHealthProfilePage() {
  const { t } = useTranslation();
  const { healthProfile, isHealthProfileLoading } = useGetHealthProfile();

  return (
    <Stack>
      <HealthScoreHeader
        title={t("MyHealth.profileHeader.title")}
        description={t("MyHealth.profileHeader.description")}
      />
      <Stack
        sx={{
          ...defaultFullscreenPageStyling,
          ...pageWithBottomNavigationStyling,
        }}
      >
        <Stack spacing={2}>
          {isHealthProfileLoading === true ? (
            <Stack alignItems="center">
              <LoadingSpinner />
            </Stack>
          ) : (
            <HealthProfile healthProfile={healthProfile} />
          )}
        </Stack>

        <BottomNavigation />
      </Stack>
    </Stack>
  );
}
